module.exports = __webpack_public_path__ + "img/v5.4425203f.svg";